import React, { useEffect, useState } from "react";
import SelectComponent from "../select";
import { getGroupsList } from "./handler";
import { useUtils } from "../../utils";

export const GroupSelection = (props) => {
  const { user_id, name, handleChange, error, org_id, clearGroups, service, multiple = true, label = "Groups*" } = props;
  const [groups, setGroups] = useState([]);
  const { showToast } = useUtils();
  const [loadingGroups, setLoadingGroups] = useState(true);

  useEffect(() => {
    if (user_id && multiple) {
      service
        .get(`/org/user_groups/${user_id}`)
        .then((res) => {
          const groupIds = res?.map(({ group_id }) => String(group_id));
          setValues(groupIds);
          handleChange(name, groupIds);
        })
        .catch((error) => {
          showToast("error", "Something went wrong while getting user groups");
        });
    }
  }, [user_id, multiple]);

  useEffect(() => {
    if (clearGroups) {
      setGroups([]);
      return;
    }

    if (service) {
      getGroupsList(service, org_id)
        .then(setGroups)
        .finally(() => {
          setLoadingGroups(false);
        });
    }
  }, [service, org_id, clearGroups]);

  const [values, setValues] = useState(multiple ? [] : "");

  return (
    <SelectComponent
      value={multiple ? (!groups?.length ? [] : values) : values}
      label={label}
      options={groups}
      onChange={(e) => {
        setValues(e.target.value);
        handleChange(name, e.target.value);
      }}
      error={!!error}
      helperText={error}
      multiple={multiple}
      disabled={loadingGroups}
      autoWidth
    />
  );
};
